import React from 'react';
import { observer } from 'mobx-react';
import { useUserCompatibility } from '@/hooks';
import { useStores } from '@/stores';
import { SignInButton } from './signInButton';
import { WriteReviewButton } from './writeReviewButton';

export const ActionButtons = observer(({ fullWidth = true }) => {
  const { isUserIncompatibleWithCurrentGallery } = useUserCompatibility();
  const { userStore } = useStores();

  return userStore.isLoggedIn ? (
    <WriteReviewButton
      fullWidth={fullWidth}
      disabled={isUserIncompatibleWithCurrentGallery}
    />
  ) : (
    <SignInButton fullWidth={fullWidth} />
  );
});
